/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  GetReportJobsCountParams,
  GetReportJobsParams,
  ReportJobDto,
  ReportJobRequestDto,
  ReportTemplateRequestDto,
  ReportTemplateResponseDto
} from '../../model';





/**
 * Can be used for request reports created by the user
 * @summary Report getter API
 */
export const getReportJobs = (
    params: GetReportJobsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ReportJobDto[]>> => {
    
    
    return axios.default.get(
      `/api/v1.1/reports`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetReportJobsQueryKey = (params?: GetReportJobsParams,) => {
    return [
    `/api/v1.1/reports`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetReportJobsQueryOptions = <TData = Awaited<ReturnType<typeof getReportJobs>>, TError = AxiosError<unknown>>(params: GetReportJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportJobs>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportJobsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportJobs>>> = ({ signal }) => getReportJobs(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportJobsQueryResult = NonNullable<Awaited<ReturnType<typeof getReportJobs>>>
export type GetReportJobsQueryError = AxiosError<unknown>


export function useGetReportJobs<TData = Awaited<ReturnType<typeof getReportJobs>>, TError = AxiosError<unknown>>(
 params: GetReportJobsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportJobs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportJobs>>,
          TError,
          Awaited<ReturnType<typeof getReportJobs>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportJobs<TData = Awaited<ReturnType<typeof getReportJobs>>, TError = AxiosError<unknown>>(
 params: GetReportJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportJobs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportJobs>>,
          TError,
          Awaited<ReturnType<typeof getReportJobs>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportJobs<TData = Awaited<ReturnType<typeof getReportJobs>>, TError = AxiosError<unknown>>(
 params: GetReportJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportJobs>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Report getter API
 */

export function useGetReportJobs<TData = Awaited<ReturnType<typeof getReportJobs>>, TError = AxiosError<unknown>>(
 params: GetReportJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportJobs>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportJobsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetReportJobsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getReportJobs>>, TError = AxiosError<unknown>>(params: GetReportJobsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportJobs>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportJobsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportJobs>>> = ({ signal }) => getReportJobs(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportJobsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getReportJobs>>>
export type GetReportJobsSuspenseQueryError = AxiosError<unknown>


export function useGetReportJobsSuspense<TData = Awaited<ReturnType<typeof getReportJobs>>, TError = AxiosError<unknown>>(
 params: GetReportJobsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportJobs>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportJobsSuspense<TData = Awaited<ReturnType<typeof getReportJobs>>, TError = AxiosError<unknown>>(
 params: GetReportJobsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportJobs>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportJobsSuspense<TData = Awaited<ReturnType<typeof getReportJobs>>, TError = AxiosError<unknown>>(
 params: GetReportJobsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportJobs>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Report getter API
 */

export function useGetReportJobsSuspense<TData = Awaited<ReturnType<typeof getReportJobs>>, TError = AxiosError<unknown>>(
 params: GetReportJobsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportJobs>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportJobsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Can be used for request report templates for targets or drivers
 * @summary Report template API
 */
export const getAvailableReports = (
    reportTemplateRequestDto: ReportTemplateRequestDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ReportTemplateResponseDto[]>> => {
    
    
    return axios.default.post(
      `/api/v1.1/reports`,
      reportTemplateRequestDto,options
    );
  }



export const getGetAvailableReportsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAvailableReports>>, TError,{data: ReportTemplateRequestDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof getAvailableReports>>, TError,{data: ReportTemplateRequestDto}, TContext> => {

const mutationKey = ['getAvailableReports'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getAvailableReports>>, {data: ReportTemplateRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  getAvailableReports(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetAvailableReportsMutationResult = NonNullable<Awaited<ReturnType<typeof getAvailableReports>>>
    export type GetAvailableReportsMutationBody = ReportTemplateRequestDto
    export type GetAvailableReportsMutationError = AxiosError<unknown>

    /**
 * @summary Report template API
 */
export const useGetAvailableReports = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAvailableReports>>, TError,{data: ReportTemplateRequestDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getAvailableReports>>,
        TError,
        {data: ReportTemplateRequestDto},
        TContext
      > => {

      const mutationOptions = getGetAvailableReportsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Can be used for request report job generation
 * @summary Report job API
 */
export const createReport = (
    reportJobRequestDto: ReportJobRequestDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/v1.1/reports/job`,
      reportJobRequestDto,options
    );
  }



export const getCreateReportMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReport>>, TError,{data: ReportJobRequestDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createReport>>, TError,{data: ReportJobRequestDto}, TContext> => {

const mutationKey = ['createReport'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createReport>>, {data: ReportJobRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  createReport(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateReportMutationResult = NonNullable<Awaited<ReturnType<typeof createReport>>>
    export type CreateReportMutationBody = ReportJobRequestDto
    export type CreateReportMutationError = AxiosError<unknown>

    /**
 * @summary Report job API
 */
export const useCreateReport = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReport>>, TError,{data: ReportJobRequestDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createReport>>,
        TError,
        {data: ReportJobRequestDto},
        TContext
      > => {

      const mutationOptions = getCreateReportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Max target number for reports
 */
export const getMaxTargetNumber = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number>> => {
    
    
    return axios.default.get(
      `/api/v1.1/reports/maxTargets`,options
    );
  }




export const getGetMaxTargetNumberQueryKey = () => {
    return [
    `/api/v1.1/reports/maxTargets`
    ] as const;
    }

    
export const getGetMaxTargetNumberQueryOptions = <TData = Awaited<ReturnType<typeof getMaxTargetNumber>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMaxTargetNumber>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMaxTargetNumberQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMaxTargetNumber>>> = ({ signal }) => getMaxTargetNumber({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMaxTargetNumber>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMaxTargetNumberQueryResult = NonNullable<Awaited<ReturnType<typeof getMaxTargetNumber>>>
export type GetMaxTargetNumberQueryError = AxiosError<unknown>


export function useGetMaxTargetNumber<TData = Awaited<ReturnType<typeof getMaxTargetNumber>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMaxTargetNumber>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMaxTargetNumber>>,
          TError,
          Awaited<ReturnType<typeof getMaxTargetNumber>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMaxTargetNumber<TData = Awaited<ReturnType<typeof getMaxTargetNumber>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMaxTargetNumber>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMaxTargetNumber>>,
          TError,
          Awaited<ReturnType<typeof getMaxTargetNumber>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMaxTargetNumber<TData = Awaited<ReturnType<typeof getMaxTargetNumber>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMaxTargetNumber>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Max target number for reports
 */

export function useGetMaxTargetNumber<TData = Awaited<ReturnType<typeof getMaxTargetNumber>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMaxTargetNumber>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMaxTargetNumberQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetMaxTargetNumberSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMaxTargetNumber>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMaxTargetNumber>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMaxTargetNumberQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMaxTargetNumber>>> = ({ signal }) => getMaxTargetNumber({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMaxTargetNumber>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMaxTargetNumberSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMaxTargetNumber>>>
export type GetMaxTargetNumberSuspenseQueryError = AxiosError<unknown>


export function useGetMaxTargetNumberSuspense<TData = Awaited<ReturnType<typeof getMaxTargetNumber>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMaxTargetNumber>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMaxTargetNumberSuspense<TData = Awaited<ReturnType<typeof getMaxTargetNumber>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMaxTargetNumber>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMaxTargetNumberSuspense<TData = Awaited<ReturnType<typeof getMaxTargetNumber>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMaxTargetNumber>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Max target number for reports
 */

export function useGetMaxTargetNumberSuspense<TData = Awaited<ReturnType<typeof getMaxTargetNumber>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMaxTargetNumber>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMaxTargetNumberSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Can be used for request report counts created by the user
 * @summary Report counter API
 */
export const getReportJobsCount = (
    params: GetReportJobsCountParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number>> => {
    
    
    return axios.default.get(
      `/api/v1.1/reports/count`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetReportJobsCountQueryKey = (params?: GetReportJobsCountParams,) => {
    return [
    `/api/v1.1/reports/count`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetReportJobsCountQueryOptions = <TData = Awaited<ReturnType<typeof getReportJobsCount>>, TError = AxiosError<unknown>>(params: GetReportJobsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportJobsCount>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportJobsCountQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportJobsCount>>> = ({ signal }) => getReportJobsCount(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportJobsCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportJobsCountQueryResult = NonNullable<Awaited<ReturnType<typeof getReportJobsCount>>>
export type GetReportJobsCountQueryError = AxiosError<unknown>


export function useGetReportJobsCount<TData = Awaited<ReturnType<typeof getReportJobsCount>>, TError = AxiosError<unknown>>(
 params: GetReportJobsCountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportJobsCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportJobsCount>>,
          TError,
          Awaited<ReturnType<typeof getReportJobsCount>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportJobsCount<TData = Awaited<ReturnType<typeof getReportJobsCount>>, TError = AxiosError<unknown>>(
 params: GetReportJobsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportJobsCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportJobsCount>>,
          TError,
          Awaited<ReturnType<typeof getReportJobsCount>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportJobsCount<TData = Awaited<ReturnType<typeof getReportJobsCount>>, TError = AxiosError<unknown>>(
 params: GetReportJobsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportJobsCount>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Report counter API
 */

export function useGetReportJobsCount<TData = Awaited<ReturnType<typeof getReportJobsCount>>, TError = AxiosError<unknown>>(
 params: GetReportJobsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportJobsCount>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportJobsCountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetReportJobsCountSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getReportJobsCount>>, TError = AxiosError<unknown>>(params: GetReportJobsCountParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportJobsCount>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportJobsCountQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportJobsCount>>> = ({ signal }) => getReportJobsCount(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportJobsCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportJobsCountSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getReportJobsCount>>>
export type GetReportJobsCountSuspenseQueryError = AxiosError<unknown>


export function useGetReportJobsCountSuspense<TData = Awaited<ReturnType<typeof getReportJobsCount>>, TError = AxiosError<unknown>>(
 params: GetReportJobsCountParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportJobsCount>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportJobsCountSuspense<TData = Awaited<ReturnType<typeof getReportJobsCount>>, TError = AxiosError<unknown>>(
 params: GetReportJobsCountParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportJobsCount>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportJobsCountSuspense<TData = Awaited<ReturnType<typeof getReportJobsCount>>, TError = AxiosError<unknown>>(
 params: GetReportJobsCountParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportJobsCount>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Report counter API
 */

export function useGetReportJobsCountSuspense<TData = Awaited<ReturnType<typeof getReportJobsCount>>, TError = AxiosError<unknown>>(
 params: GetReportJobsCountParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportJobsCount>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportJobsCountSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




